export default {
  receiving_object: 'Receiver',
  receiving_object_tips:'Please match buyers who can see your publisher network',
  receiving_object_tips2: 'Please match the exhibitors who can see your publisher network',
  requirement_content: 'Requirement',
  upload_pictures_or_videos: 'Upload pictures/videos',
  upload_desc: 'Cannot upload pictures and videos together',
  published_successfully: 'Publish successfully',
  comment: 'Comment',
  like: 'Like',
  op_invitation: 'Inviatation',
  reply: 'Reply',
  // release_requirements: 'Post requirement',
  release_requirements: 'Publish News Feeds',
  my_releases: 'Biz hub management',
  please_select: 'Please select',
  select_exhibits_title: 'Please select exhibit category',
  select_receiving_alter: 'Please select receiver',
  opportunity_management: 'Business opportunity management',
  op_publish: 'Publish',
  "Your publisher's cycle count has reached its limit":"Your published News Feeds has reached the limit",
  uploadTips_1: '1.The photo should be square, png or jpg format and not greater than 1Mb.You can upload up to nine pictures',
  uploadTips_2: '2.The video supports mp4, avi, flv format, no more than 100Mb, you can upload a video and a video cover',
  uploadTips_3: '3.Uploading a video will empty the uploaded image.	',
  uploadTips_4: 'A total of ',
  uploadTips_5: 'sheets',
  uploadTips_6: 'you can also upload ',

  'Notice': 'Notice：',
  'Upload picture': 'Upload image'
}